<template>
  <div>
    <div  id="mobile-nav-bar">
      <b-navbar toggleable="lg" type="dark">
        <b-navbar-toggle
          target="nav-collapse"
          class="mt-4 mb-6 mr-0"
        >
      </b-navbar-toggle>
        <div id="logo-2-display"><v-img :src="LogoPath" width="100"></v-img></div>
        <div id="logout-icon">
          <img
            src="/assets/images/users/avatar-1.jpg"
            alt="user-image"
            width="32"
            class="rounded-circle"
          />
          <v-btn plain @click="LogoutUser" class="white--text">
            <v-icon>mdi-exit-to-app</v-icon>
            <span id="logout-txt">Logout</span>
          </v-btn>
        </div>
        <b-collapse id="nav-collapse" is-nav>
          <nav-link></nav-link>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>
<script>
import NavLink from "@/components/header/NavLink.vue";
import Common from "@/Common.vue";
import companyConfig from "@/company_config.json";
export default {
  mixins: [Common],
  components: {
    NavLink,
  },
  data() {
    return {
      LogoPath: "",
    };
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      var server_url = companyConfig.apiURL;
      this.LogoPath = server_url + "assets/images/logo.png";
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
